import { useState, useEffect } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import axios from "axios";

import BrandLogo from "@/components/BrandLogo";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [token, setToken] = useState(params.get("token") || "");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  async function handleSubmit(e) {
    e.preventDefault();
    setError(""); setSuccess("");
    if (password !== confirm) {
      setError("Passwords do not match."); return;
    }
    if (password.length < 6) {
      setError("Password must be at least 6 characters."); return;
    }
    setLoading(true);
    try {
      const res = await axios.post(`${API}/auth/reset-password`, { token, new_password: password });
      setSuccess(res.data.message);
      setTimeout(() => navigate("/login"), 2000);
    } catch (err) {
      setError(err.response?.data?.detail || "Reset failed. The token may be invalid or expired.");
    } finally { setLoading(false); }
  }

  return (
    <div className="auth-shell">
      <div className="auth-panel-left">
        <div className="auth-brand">
          <BrandLogo variant="auth" />
          <div className="auth-brand-desc">Create a new secure password for your account.</div>
        </div>
      </div>

      <div className="auth-panel-right">
        <div className="auth-form-title">Reset Password</div>
        <div className="auth-form-sub">Enter your reset token and new password</div>

        {error   && <div className="auth-error"   data-testid="reset-error">{error}</div>}
        {success && <div className="auth-success" data-testid="reset-success">{success} Redirecting to login...</div>}

        <form onSubmit={handleSubmit}>
          <div className="auth-field">
            <label className="auth-label">Reset Token</label>
            <input className="auth-input" style={{ fontFamily: "var(--mono)", fontSize: 11 }}
              placeholder="Paste your reset token here"
              value={token} onChange={e => setToken(e.target.value)}
              required data-testid="reset-token-input"
            />
          </div>
          <div className="auth-field">
            <label className="auth-label">New Password</label>
            <input type="password" className="auth-input" placeholder="Min. 6 characters"
              value={password} onChange={e => setPassword(e.target.value)}
              required data-testid="reset-password-input"
            />
          </div>
          <div className="auth-field">
            <label className="auth-label">Confirm New Password</label>
            <input type="password" className="auth-input" placeholder="Re-enter new password"
              value={confirm} onChange={e => setConfirm(e.target.value)}
              required data-testid="reset-confirm-input"
            />
          </div>
          <button type="submit" className="auth-submit" disabled={loading || !!success} data-testid="reset-submit-btn">
            {loading ? "Resetting..." : "Reset Password"}
          </button>
        </form>

        <div className="auth-link">
          <Link to="/forgot-password" data-testid="back-to-forgot-link">Get a new token</Link>
          {" · "}
          <Link to="/login" data-testid="back-to-login-link">Sign In</Link>
        </div>
      </div>
    </div>
  );
}
